import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Users } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { PageMasthead } from "@/components/ui-custom/PageMasthead";
import { RevealStagger, staggerItem } from "@/components/ui-custom/RevealOnScroll";
import { motion } from "framer-motion";

export default function Direktori() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async (q = "") => {
    setLoading(true);
    try {
      const res = await api.get("/public/directory", { params: { search: q || undefined, limit: 24 } });
      setItems(res.data.items);
      setTotal(res.data.total);
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div data-testid="direktori-page">
      <PageMasthead breadcrumb="DIREKTORI" title="Direktori Ahli PPPS" subtitle={`Senarai ahli PPPS yang aktif dan disahkan (${total} ahli berdaftar).`} />

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <form onSubmit={(e) => { e.preventDefault(); load(search); }} className="flex gap-3 mb-10 max-w-md">
          <Input
            data-testid="directory-search-input"
            placeholder="Cari nama, No. Ahli atau syarikat"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="bg-white"
          />
          <Button type="submit" data-testid="directory-search-btn" className="bg-piks-black hover:bg-piks-black/90 shrink-0">
            <Search className="w-4 h-4" />
          </Button>
        </form>

        {loading ? (
          <div className="text-center py-16 text-piks-muted">Memuatkan direktori...</div>
        ) : items.length === 0 ? (
          <div className="text-center py-16 text-piks-muted" data-testid="directory-empty-state">
            <Users className="w-10 h-10 mx-auto mb-3 opacity-40" />
            Tiada ahli dijumpai.
          </div>
        ) : (
          <RevealStagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" staggerDelay={0.05}>
            {items.map((m) => (
              <motion.div key={m.member_number} variants={staggerItem}>
              <Link
                to={`/member/${m.member_number}`}
                data-testid={`directory-member-card-${m.member_number}`}
                className="p-5 rounded-xl bg-white border border-piks-border hover:border-piks-gold/60 hover:-translate-y-1 hover:shadow-md transition-all duration-300 block"
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-11 h-11 rounded-full bg-piks-ivory border border-piks-border flex items-center justify-center shrink-0">
                    <span className="font-display text-piks-black">{m.full_name?.[0] || "A"}</span>
                  </div>
                  <div className="min-w-0">
                    <p className="font-semibold text-piks-black truncate">{m.full_name}</p>
                    <p className="text-[11px] font-mono text-piks-muted">{m.member_number}</p>
                  </div>
                </div>
                <p className="text-xs text-piks-muted">{m.category}</p>
                {m.company_name && <p className="text-xs text-piks-black font-medium mt-0.5 truncate">{m.company_name}</p>}
              </Link>
              </motion.div>
            ))}
          </RevealStagger>
        )}
      </section>
    </div>
  );
}
